import { useEffect, useState } from "react";
import { i18n } from '../../lang/i18n';
import DC from "../../common/DataConnector";
import BrewScreen from "./BrewScreen";
import RecipeScreen from "./RecipeScreen";

export default function TabRecipes()
{
    const [recipes, setRecipes] = useState<any[]>([])
    const [brews, setBrews] = useState<any[]>([])
    const [recipe, setRecipe] = useState<any>(undefined)

    useEffect(() =>
    {
        (async function ()
        {
            const result = await DC.Get('/customer/recipes');
            if (result.wasOk) {
                setRecipes(result.data.filter((b: any) => b.type === 'dessert' || b.type === 'cocktail'))
                setBrews(result.data.filter((b: any) => b.type === 'coffee'))
            }
        })();
    }, []);


    return (
        <div className="container">
            <div className={recipe ? "hidden" : "recipes"}>
                <h2 className="text-center mb-3">{i18n.Recipes.BrewTitle}</h2>
                {brews.map((item: any, index: number) => (
                    <div key={index} onClick={() => setRecipe(item)} className="recipes-item">
                        <div style={{ width: 80 }} className="recipe-image">
                            {item.photo && item.photo.url250 && <img src={item.photo.url250} alt="" />}
                        </div>
                        <div className="recipe-title">
                            <h2>{item.name}</h2>
                        </div>
                    </div>
                ))}
                <h2 className="text-center mb-3">{i18n.Recipes.RecipesTitle}</h2>
                {recipes.map((item: any, index: number) => (
                    <div key={index} onClick={() => setRecipe(item)} className="recipes-item">
                        <div style={{ width: 80 }} className="recipe-image">
                            {item.photo && item.photo.url250 && <img src={item.photo.url250} alt="" />}
                        </div>
                        <div className="recipe-title">
                            <h2>{item.name}</h2>
                        </div>
                    </div>
                ))}
            </div>
            {recipe && <>
                {recipe.type === 'coffee' && <BrewScreen recipe={recipe} />}
                {recipe.type !== 'coffee' && <RecipeScreen recipe={recipe} />}
                <div className="btn-back link-btn  btn-fixed-lb" onClick={() => setRecipe(undefined)}>
                    <i className="fa fa-arrow-left" /> {i18n._BTNs.Back}
                </div>
            </>}
        </div>
    )
}